module.exports = __webpack_public_path__ + "b45814deb72dedde9ea91420bf2f019b.svg";